import React, { useState, useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import axios from 'axios';

const RecaptchaProviderWrapper = ({ children }) => {
  const [siteKey, setSiteKey] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSiteKey = async () => {
      try {
        // Fetch site key from backend
        const response = await axios.get('/api/Public/recaptcha/site-key');
        if (response.data && response.data.siteKey) {
          setSiteKey(response.data.siteKey);
          console.log('reCAPTCHA Site Key loaded from backend');
        } else {
          console.warn('reCAPTCHA Site Key not found in backend response');
        }
      } catch (error) {
        console.error('Error fetching reCAPTCHA Site Key from backend:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSiteKey();
  }, []);

  // Show loading state or render without reCAPTCHA if site key is not available
  if (loading) {
    return <div>{children}</div>; // Render children without reCAPTCHA while loading
  }

  if (!siteKey) {
    console.warn('reCAPTCHA Site Key is not configured. reCAPTCHA will not work.');
    return <div>{children}</div>; // Render children without reCAPTCHA
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      language="en"
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaProviderWrapper;

